module.exports = {
  translate: [ 'value', require(54) ]
};